import { MouseEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { userDataSelector } from '@store/features/auth/user/selectors';
import { fetchCategories, selectCategories } from '@store/features/recources/slice';
import useDispatch from '@store/hooks/useDispatch';

export const useCategoriesAndResourcesNav = () => {
  const user = useSelector(userDataSelector);
  const categories = useSelector(selectCategories);
  const [isResourcesActive, setIsRecourceActive] = useState<boolean>(false);

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    setIsRecourceActive(
      location.pathname.split('/').includes('category') ||
        location.pathname.split('/').includes('resource'),
    );
  }, [location.pathname]);

  useEffect(() => {
    if (user && !user.isAdmin && user.organizationId !== null) {
      dispatch(fetchCategories());
    }
  }, [user, dispatch]);

  const [anchorResourcesNav, setAnchorResourcesNav] = useState<null | HTMLElement>(null);
  const handleOpenResourcesNav = (event: MouseEvent<HTMLElement>): void => {
    setAnchorResourcesNav(event.currentTarget);
  };
  const handleCloseResourcesNav = (): void => {
    setAnchorResourcesNav(null);
  };

  return {
    isResourcesActive,
    categories,
    anchorResourcesNav,
    handleOpenResourcesNav,
    handleCloseResourcesNav,
  };
};
